import { tv } from 'tailwind-variants';

export const defaultVariants = tv({
  slots: {
    base: [],
    heading: ['heading-2', 'text-textPrimary'],
  },
});

export const tabbedChartVariants = tv({
  slots: {
    wrapper: ['w-full'],
    tabList: ['flex flex-col md:flex-row gap-[5px]', 'border-b border-light-gray'],
    tab: [
      'px-5 py-2.5',
      'bg-light-gray',
      'text-textPrimary',
      'text-lg font-light leading-[27px]',
      'rounded md:rounded-b-none md:rounded-t-[5px]',
      'cursor-pointer',
      'transition-colors',
    ],
    tabActive: ['bg-medium-gray'],
    tabInactive: ['hover:text-textPrimary/60'],
    content: ['border-t border-medium-gray', 'p-2.5', 'overflow-x-hidden'],
  },
});
